<template>
    <div class="collapsible-body">
        <div class="row baseheader" style="width: 100%;" v-if="newPest == undefined">
            <div class="col s1">
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setPestsOrder('name')" style="padding-left: 5px !important;">{{$t('pests.name')}}</span>
                <i class="material-icons dp6" v-if="orderpestby == 'name' && orderpest == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderpestby == 'name' && orderpest == 'asc'">arrow_drop_up</i>
                <input v-model="pestsearch" />
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setPestsOrder('group_priority')" style="padding-left: 5px !important;">{{$t('pests.category')}}</span>
                <i class="material-icons dp6" v-if="orderpestby == 'group_priority' && orderpest == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderpestby == 'group_priority' && orderpest == 'asc'">arrow_drop_up</i>
                <selector v-model="selectedpestsgroups" :items="pestsgroups" identifier="pestsgroups"></selector>
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setPestsOrder('tag_list')" style="padding-left: 5px !important;">{{$t('pests.group')}}</span>
                <i class="material-icons dp6" v-if="orderpestby == 'tag_list' && orderpest == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderpestby == 'tag_list' && orderpest == 'asc'">arrow_drop_up</i>
                <selector v-model="selectedpesttags" :items="peststagsgroups" identifier="peststags"></selector>
            </div>
            <div class="col s2 input-field" style="text-align: end;" v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)">
                <a class="waves-effect waves-light btn solidgreen" v-on:click="addPest()" style="margin-top: 20px;" v-if="newPest == undefined">{{$t('pests.add')}}</a>
            </div>
        </div>
        <ul class="collapsible">
            <li v-if="newPest != undefined">
                <pest
                    v-bind:pest="newPest" 
                    v-bind:index="-1" 
                    v-bind:pest_groups="pest_groups" 
                    v-bind:peststagsgroups="peststags" 
                    v-bind:peststagsgroupsstring="peststagsgroupsstring" 
                    v-on:addPest="addedPest" 
                    v-on:cancelPest="pestCancelled"
                    ref="newPest" />
            </li>
            <li v-for="(pest, index) in listPestItems" :key="pest.id">
                <div class="collapsible-header reded">
                    <div class="row" style="width: 100%;">
                        <div class="col s1">
                            <template v-if="pest.image != null && pest.image != undefined">
                                <v-lazy-image
                                    v-bind:src="pest.image"
                                    src-placeholder="/nofoto.png"
                                    width="64" 
                                    v-on:error="imageLoadError(pest)"
                                />
                            </template>
                            <template v-else>
                                <img src="/nofoto.png" style="width: 64px;"/>
                            </template>
                        </div>
                        <div class="col s3"> {{pest.name}}</div>
                        <div class="col s3"> {{pest.group_name}}</div>
                        <div class="col s3" style="padding-left: 23px;"> {{pest.tags.join(", ")}}</div>
                    </div>
                </div>
                <pest 
                    v-bind:pest="pest" 
                    v-bind:index="index" 
                    v-bind:pest_groups="pest_groups" 
                    v-bind:peststagsgroups="peststags" 
                    v-on:removePest="removePest" 
                    v-on:updatePest="updatePest" 
                    v-bind:peststagsgroupsstring="peststagsgroupsstring"
                    ref="pests" />
            </li>
            <li>
                <div class="row" style="width: 100%;"  v-if="pests_loaded == false">
                    <div class="col s12">
                        <div class="container" style="width: 3%; margin: auto;">
                            <div class="preloader-wrapper active">
                                <div class="spinner-layer spinner-red-only">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="gap-patch">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="pests_loaded == true && listPestItems.length == 0">
                    <div class="col s12">{{$t('pests.notfound')}}</div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';

export default {
    props: { role: String, extended_privileges: Boolean },
    data: function() {
        return {
            orderpest: 'desc',
            orderpestby: 'name',
            pestsearch: "",
            pests: [],
            pest_groups: [],
            pest_groups_options: [],
            pests_loaded: false,
            pestsgroups: [],
            groups: [],
            peststagsgroups: [],
            peststags: [],
            selectedpestsgroups: [],
            selectedpesttags: [],
            newPest: undefined
        }
    },
    created() {
        this.fetch_pests();
    },
    mounted() {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, { accordion: true });
    },
    methods: {
        removePest: function(pest) {           
            var that = this;
            axios.delete("/pests/" + pest.id + ".json").then((response) => {
                that.pests.splice(that.pests.indexOf(pest), 1);
            })
        },
        addedPest: function(pest) {
            this.pests.push(pest);
            this.newPest = undefined;
            this.$forceUpdate();
        },
        updatePest: function(pest){
            var oldpest = _.find(this.pests, {id: pest.id});
            _.assign(oldpest, pest);
            oldpest.tags = _.map(oldpest.tag_list, 'name')
            this.$forceUpdate();
        },
        anyEdited: function(){
            if(_.isUndefined(this.$refs.pests) == false){
                for (var i = this.$refs.pests.length - 1; i >= 0; i--) {
                    if(this.$refs.pests[i].editedpest.edit){
                        return true;
                    }
                }
            }
            if(_.isUndefined(this.$refs.newPest) == false){
                if(this.$refs.newPest.editedpest.edit){
                    return true;
                }
            }
            return false;
        },
        fetch_pests: function() {
            var that = this;
            axios.get('/pests.json').then(response => {
                this.pests = response.data;
                for (var i = this.pests.length - 1; i >= 0; i--) {
                    this.pests[i].edit = false;
                    this.groups = _.uniqBy(_.union(this.groups, [this.pests[i].group]), function(group) {
                        return group.id;
                    }) 
                    this.pestsgroups = _.uniq(_.union(this.pestsgroups, [this.pests[i].group_name]))
                    this.pests[i].tags = _.map(this.pests[i].tag_list, 'name');
                    this.peststagsgroups = _.uniq(_.union(this.peststagsgroups, this.pests[i].tags))
                }
                this.groups = _.sortBy(this.groups, function(group){
                    return group.priority;
                }, ["desc"])
                this.pestsgroups = _.map(this.groups, pestgroup => {
                    return { name: pestgroup.name, value: pestgroup.name };
                })
                this.peststags = this.peststagsgroups
                this.peststagsgroupsstring = _.map(this.peststags, pestgroup => {
                    return { text: pestgroup };
                })
                this.peststagsgroups = _.map(this.peststagsgroups, pestgroup => {
                    return { name: pestgroup, value: pestgroup };
                })
                this.pests_loaded = true;
            });
            axios.get('/groups.json').then(response => {
                this.pest_groups = response.data;
                this.pest_groups_options = _.map(this.pest_groups, pestgroup => {
                    return { name: pestgroup.name, value: pestgroup.id };
                })
            });
            axios.get("/dev_types.json").then((response) => {
                this.dev_types = response.data
            });
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        pestCancelled: function(pest) {
            this.newPest = undefined;
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        addPest() {
            this.newPest = {
                edit: true,
                name: "",
                group_name: "",
                tag_list: [],
                tags: '',
                media: []
            }
            this.$forceUpdate();
        },

        setPestsOrder: function(order) {
            if (this.orderpestby == order) {
                if (this.orderpest == 'desc') {
                    this.orderpest = 'asc'
                } else if (this.orderpest == 'asc') {
                    this.orderpest = 'desc'
                }

            } else {
                this.orderpestby = order;
            }
        },
        imageLoadError: function(pest){
            pest.image = null;
        }
    },
    computed: {
        listPestItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.pests, this.orderpestby, this.orderpest),
                function(item) {
                    return (item.name.toUpperCase().indexOf(that.pestsearch.toUpperCase()) >= 0) &&
                        (_.includes(that.selectedpestsgroups, item.group_name) || that.selectedpestsgroups.length == 0) &&
                        (_.intersection(that.selectedpesttags, _.map(item.tag_list, 'name')).length > 0 || that.selectedpesttags.length == 0)
                }
            );
        },

    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.settingsform {
    padding-top: 15px;
}

.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

.formul .row .col {
    padding-bottom: 15px;
}

.formul .s12 .input-field {
    width: 90%
}

.formul .s4 .input-field {
    width: 60%
}

.formul .s6 .input-field {
    width: 60%
}

.input-field {
    margin: 0px 0px 5px 0px !important;
}

.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

.collapsible-body .collapsible-header {
    background-color: #FFF;
    text-transform: initial;
}

.collapsible-body .collapsible-header .row {
    margin-bottom: 0px;
}

.collapsible-body .collapsible-body.formul {
    background-color: #FFF;
    margin-top: 5px;
    border-bottom-style: solid;
    border-bottom-width: 5px;
}

.baseheader {
    background-color: #DADADA;
    margin-bottom: 0px;
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.collapsible li {
    padding-bottom: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.active>.reded {
    border-color: rgb(194, 32, 38);
    border: 4px solid rgb(194, 32, 38);
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inline>select {
    display: block !important;
}

.collapsible-body {
    padding: 1em;
    padding-right: 0em;
    padding-left: 1em;
}

.collapsible li i {
    position: absolute;
    right: 15px;
}

.collapsible li.active i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
    transform: rotate(180deg);
}

.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.btn-small {
    color: black;
    border-radius: 8px;
}

/deep/ .ti-input {
    min-height: 35px;
}
</style>